export default {
  companyUserGetList: {
    method: 'post',
    url: '/company/user/list'
  },
  getCompanyBranch: {
    method: 'post',
    url: '/company/branch/get-company-branchs'
  },
  getList: {
    method: 'post',
    url: '/company/list'
  },
  getHoldingCompany: {
    method: 'get',
    url: '/company/holding-company'
  },
  updateCompanyInfo: {
    method: 'post',
    url: '/company/edit-information'
  },
  getCompanyUser: {
    method: 'post',
    url: '/company/user'
  },
  selectCompanyUser: {
    method: 'get',
    url: '/company/user/find?key=KEY&groupType=GROUPTYPE'
  },
  historyList: {
    method: 'post',
    url: '/company/history/list'
  },
  updateInvoice: {
    method: 'post',
    url: '/company/update-invoice'
  },
  updateBanking: {
    method: 'post',
    url: '/company/update-banking'
  },
  find: {
    method: 'get',
    url: '/company/find?key=KEY&type=TYPE'
  },
  companyUserArchive: {
    method: 'delete',
    url: '/company/user/archive'
  },
  companyGroupArchive: {
    method: 'delete',
    url: '/company/group/archive'
  },
  users: {
    resendActivation: {
      method: 'post',
      url: '/company/user/ID/resend-activation'
    }
  },
  api_key: {
    create: {
      method: 'post',
      url: '/company/api-key'
    },
    get: {
      method: 'post',
      url: '/company/api-key/list'
    },
    edit: {
      method: 'put',
      url: '/company/api-key/ID'
    },
    archive: {
      method: 'delete',
      url: '/company/api-key/archive'
    },
    delete: {
      method: 'delete',
      url: '/company/api-key'
    }
  },
  integration: {
    freightek: {
      workspaces: {
        method: 'get',
        url: '/apps/freightek/workspaces'
      },
      changeWorkspace: {
        method: 'put',
        url: '/apps/freightek/workspace'
      }
    },
    external: {
      create: {
        method: 'post',
        url: '/apps'
      },
      gets: {
        method: 'get',
        url: '/apps'
      },
      get: {
        method: 'get',
        url: '/apps/ID'
      },
      update: {
        method: 'put',
        url: '/apps/ID'
      },
      delete: {
        method: 'delete',
        url: '/apps/ID'
      }
    },
    internal: {
      create: {
        method: 'post',
        url: '/company/integration/internal'
      },
      gets: {
        method: 'post',
        url: '/company/integration/internal/list'
      },
      get: {
        method: 'post',
        url: '/company/integration/internal/ID'
      },
      respond: {
        method: 'post',
        url: '/company/integration/internal/respond'
      },
      delete: {
        method: 'delete',
        url: '/company/integration/internal'
      }
    }
  }
}
